import CountryActions from 'back_office/v2/redux/actions/country_actions'

export const fetchCountriesAndProvinces = (properties = {}) => {
  CountryActions.fetchAll({
    page: { size: 300 },
    include: 'provinces',
    ...properties
  })
}
